import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  function extractUser(session) {
    if (!session?.user) return null;
    const u = session.user;
    const meta = u.user_metadata || {};

    // Email signup stores firstName/lastName directly
    // Google/Apple store full_name or name
    let firstName = meta.firstName || '';
    let lastName = meta.lastName || '';

    if (!firstName && meta.full_name) {
      const parts = meta.full_name.split(' ');
      firstName = parts[0] || '';
      lastName = parts.slice(1).join(' ') || '';
    }
    if (!firstName && meta.name) {
      const parts = meta.name.split(' ');
      firstName = parts[0] || '';
      lastName = parts.slice(1).join(' ') || '';
    }

    return {
      id: u.id,
      email: u.email,
      firstName,
      lastName,
    };
  }

  useEffect(() => {
    // Get initial session
    const session = supabase.auth.session();
    setUser(extractUser(session));
    setToken(session?.access_token || null);
    setLoading(false);

    // Listen for auth changes
    const { data: subscription } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(extractUser(session));
      setToken(session?.access_token || null);
    });

    return () => subscription?.unsubscribe();
  }, []);

  const logout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
